// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

const url = URL;

export { url as URL };
